var _defs, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUtilitiesicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#eef8ff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M23,22H21.7l-1.9-6H4.2L2.3,22H1a1,1,0,0,0,0,2H23a1,1,0,0,0,0-2Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M17.9,10H6.1L4.8,14H19.2Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M15,.7A1.2,1.2,0,0,0,14,0H10A1.2,1.2,0,0,0,9,.7L6.7,8H17.3Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUtilitiesicon);
export default __webpack_public_path__ + "static/media/utilitiesicon.060454522a08d09bcc11292833531978.svg";
export { ForwardRef as ReactComponent };